export enum DialInCountriesArrayItemCountryFor {
  SpeakersAndParticipants = 'Speakers_And_Participants',
  SpeakersOnly = 'Speakers_Only',
  ParticipantsOnly = 'Participants_Only',
}

export interface IDialInCountriesArrayItem {
  countryId: string,
  countryFor: DialInCountriesArrayItemCountryFor,
  countryDisplay?: boolean, // exists only for ManagerCall
}
